import WalletForm from './WalletForm';

export default WalletForm;